import { CookieStorage } from 'cookie-storage';
import storageAvailable from 'storage-available'

const tokenStorage = storageAvailable('localStorage') ? localStorage : new CookieStorage();

export default tokenStorage;
